import { styled } from 'styled-components';

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
